import { useAuthenticatedQueries } from "@l2r-front/l2r-auth"

import { documentQueryKeys } from "./queryKeys"

export function useVerticalSignTypeQueries(verticalSigns = [], config = {}) {
    const uniqueTypes = [...new Set(verticalSigns.map(verticalSign => verticalSign.vertical_sign_type))]
    const queries = uniqueTypes.map(type => {
        const url = `vertical_signing/vertical_sign_types/${type}/`
        const queryKey = documentQueryKeys.verticalSignTypes(type)

        return ({
            url,
            queryKey,
            queryParameters: {},
            config: {
                ...config,
                autoRefetch: true,
            },
        })
    })

    return useAuthenticatedQueries(queries)
}